<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Skapa slopat uppehåll
      </v-card-title>

      <v-card-text class="mt-2">
        <RejectedStopActivitySearch />
        <RejectedStopLocationFields />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="createPending">
          Skapa slopat uppehåll
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import RejectedStopLocationFields from './RejectedStopForm/RejectedStopLocationFields'
import RejectedStopActivitySearch from './RejectedStopForm/RejectedStopActivitySearch'

export default {
  name: 'RejectedStopCreateModal',

  components: {
    RejectedStopLocationFields,
    RejectedStopActivitySearch
  },

  data: () => ({
    required,
    valid: true,
    createPending: false
  }),

  created() {
    this.$store.set(
      'rejectedStop/model@event_uuid',
      this.$store.get('event/selectedUUID')
    )
    if (this.model.places) {
      this.$store.set(
        'rejectedStop/model@places',
        this.model.places.split(', ')
      )
    }
  },

  computed: {
    model: sync('rejectedStop/model')
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.createPending = true

      const payload = {
        ...this.model,
        places: this.model.places.join(', '),
        from: this.model.places[0],
        to: this.model.places[0],
        checked: true
      }

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateTrainDeviationInput!) {
            createTrainDeviation(payload: $payload) {
              train_deviation_uuid
            }
          }
        `,
        variables: {
          payload
        }
      })

      this.createPending = false
      this.$store.commit('trainDeviation/create', payload)
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('rejectedStop/resetModel')
      this.$emit('close')
    }
  }
}
</script>
